import React, { useEffect, useRef, useState } from "react";
import ArtifactHistory from ".";
import { Box } from "@mui/material";
import { BASE_URL } from "../../../constant/apiUrl";
import { getAPI } from "../../../API/ApiService";
import Loading from "../../../utils/Loader";
import { prepareCurtatorTableData } from "../../../utils/function";
import {
  setDeniedHistoryContentLevel,
  setDeniedHistoryContentType,
  setDeniedHistoryVisibility,
} from "../../../slices/curatorPageSlice";
import { useDispatch, useSelector } from "react-redux";
import { CURATOR_PAGE_API_CONSTANT } from "../../../constant/constant";
import { setSearchText } from "../../../slices/curatorPageLookupSlice";

function Histroy({ pageName }) {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  const dispatch = useDispatch();
  const { selectedCuratorPage } = useSelector((state) => state.curatorpage);
  const fetchedRef = useRef(false);
  const pollingIntervalRef = useRef(null);
  const POLLING_INTERVAL = 2 * 60 * 1000; // 2 minutes in milliseconds

  const urlSelector = (pageName) => {
    switch (pageName) {
      case CURATOR_PAGE_API_CONSTANT.artificat_history:
        return `${BASE_URL}/curator/approved-list`;
      case CURATOR_PAGE_API_CONSTANT.denied_history:
        return `${BASE_URL}/curator/denied-list`;
      case CURATOR_PAGE_API_CONSTANT.archives:
        return `${BASE_URL}/curator/archived/find-all`;
      default:
        break;
    }
  };
  
  const fetchDeniedHistory = async (silent = false) => {
    if (!silent) {
      setLoading(true);
    }
    try {
      const response = await getAPI(urlSelector(pageName));
      const newData = prepareCurtatorTableData(response?.data);
      setData(newData);
      return newData;
    } catch (err) {
      // Handle error if needed
      console.error("Error fetching data:", err);
      return null;
    } finally {
      if (!silent) {
        setLoading(false);
      }
    }
  };

  // Check if any items are still processing
  const hasProcessingItems = (dataArray) => {
    return dataArray?.some((item) => item.processing === true);
  };

  // Setup polling for processing items
  const setupPolling = (currentData) => {
    // Clear existing interval if any
    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
      pollingIntervalRef.current = null;
    }

    // Only poll for artifact history page
    if (pageName !== CURATOR_PAGE_API_CONSTANT.artificat_history) {
      return;
    }

    // Check if there are any processing items
    if (!currentData || !hasProcessingItems(currentData)) {
      return;
    }

    // Set up polling interval
    pollingIntervalRef.current = setInterval(async () => {
      const updatedData = await fetchDeniedHistory(true);
      
      // Stop polling if no items are processing anymore or if fetch failed
      if (!updatedData || !hasProcessingItems(updatedData)) {
        if (pollingIntervalRef.current) {
          clearInterval(pollingIntervalRef.current);
          pollingIntervalRef.current = null;
        }
      }
    }, POLLING_INTERVAL);
  };

  useEffect(() => {
    dispatch(setDeniedHistoryContentType(""));
    dispatch(setDeniedHistoryVisibility(""));
    dispatch(setDeniedHistoryContentLevel(""));
  }, [selectedCuratorPage]);
  
  useEffect(() => {
    dispatch(setSearchText(""));
  }, []);

  useEffect(() => {
    // Clear polling when pageName changes
    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
      pollingIntervalRef.current = null;
    }
    // Reset fetchedRef and fetch data when pageName changes
    fetchedRef.current = false;
    fetchDeniedHistory();
  }, [pageName]);

  // Setup polling when data changes and has processing items
  useEffect(() => {
    if (data.length > 0 && pageName === CURATOR_PAGE_API_CONSTANT.artificat_history) {
      setupPolling(data);
    }

    // Cleanup on unmount or when pageName changes
    return () => {
      if (pollingIntervalRef.current) {
        clearInterval(pollingIntervalRef.current);
        pollingIntervalRef.current = null;
      }
    };
  }, [data, pageName]);

  return (
    <Box>
      <ArtifactHistory pageName={pageName} Tabledata={data} loading={loading} refreshData={fetchDeniedHistory} />
    </Box>
  );
}

export default Histroy;
